module.exports = __webpack_public_path__ + "img/favicon.ded91f93.svg";